import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {navigation} from "app/navigation/navigation";
import { FuseNavigation } from '@fuse/types';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnInit {

  currentURL: string;
  nav: FuseNavigation[];
  breadcrumbList: Array<any> = [{name: this._translate.instant('NAV.BREADCRUMB'), path: ''}];

  constructor(
    private _router: Router,
    private _nav: FuseNavigationService,
    private _translate: TranslateService
  ) { 
    this.currentURL = _router.url;
    this.nav = navigation;
  }

  ngOnInit(): void {
    this.checkBreadcrumbs(this.nav);
  }

  has(obj, key) {
    return key.split(".").every(function(x) {
        if(typeof obj != "object" || obj === null || obj === undefined || !(x in obj))
            return false;
        obj = obj[x];
        return true;
    });
  }

  checkBreadcrumbs(object){
    object.forEach(navItem => {

      //Check if the nav item has an URL and if the URL is the same as the Route
      //Check if there are any avalaible breadcrumbs, set the breadcrumbs by the IDs from the nav item
      if(this.has(navItem, 'url') && this.currentURL.startsWith(navItem.url) &&
        this.has(navItem, 'breadcrumb') && navItem.breadcrumb.length > 0 ){
        
        let newList = this.setBreadcrumbsById(navItem.breadcrumb);
        this.breadcrumbList = newList.length > 0? newList : this.breadcrumbList;
        return;

      }
      //Check again for the children array
      if(this.has(navItem, 'children') && navItem.children.length > 0){
          
          this.checkBreadcrumbs(navItem.children);

      }
    })
  }

  setBreadcrumbsById(breadcrumbIds){

    let bcList = [];

    breadcrumbIds.forEach(id => {

      let bc = this._nav.getNavigationItem(id);
      if(bc && bc != undefined && bc != null){
        console.log(bc);
        bcList.push({
          name: this._translate.instant(bc.translate),
          path: bc.url
        })
      }
    });

    return bcList;
  }

}
